import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    pathToTranslate() {
      let result = 'isActive'
      if (this.value.isBlocked && this.value.isActive) {
        result = 'isBlocked'
      }

      return result
    }
  },

  render
}
